import { render, staticRenderFns } from "./PriceManagement.vue?vue&type=template&id=350b47e3&scoped=true"
import script from "./PriceManagement.vue?vue&type=script&lang=js"
export * from "./PriceManagement.vue?vue&type=script&lang=js"
import style0 from "./PriceManagement.vue?vue&type=style&index=0&id=350b47e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350b47e3",
  null
  
)

export default component.exports